import { IDENTIFIER } from '../actions';
import { ListReducerBuilder } from '../../../../utils/reducers';

export default ListReducerBuilder.build(IDENTIFIER);
